import { render, staticRenderFns } from "./MortgageTab.vue?vue&type=template&id=3c3b99dd&lang=pug&"
import script from "./MortgageTab.vue?vue&type=script&lang=ts&"
export * from "./MortgageTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports